export default "__VITE_ASSET__BmxRIXny__"